import { render } from "./PermissionsUser.vue?vue&type=template&id=3871fc32"
import script from "./PermissionsUser.vue?vue&type=script&lang=js"
export * from "./PermissionsUser.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__